import {
  BACKLOG_SET_FILTERS,
  BACKLOG_CLEAR_FILTERS,
  BACKLOG_SET_PAGE,
  BACKLOG_SET_PAGE_SIZE,
  BACKLOG_SET_SEARCH,
  BACKLOG_SET_SORT,
  BACKLOG_FETCH_REQUEST,
  BACKLOG_FETCH_SUCCESS,
  BACKLOG_FETCH_FAILURE,
  BACKLOG_SET_LABEL_FILTER,
} from '../actions/actionTypes';
import { BacklogAction, BacklogLabelFilter } from '../actions/backlogActions';
import { FiltersState, EMPTY_FILTERS } from '../../Talent/components/FiltersDrawer';
import { RawTalentRow } from '../../Talent/transformers/talentTransformer';

export interface BacklogState {
  filters: FiltersState;
  search: string;
  sort: { column: string; direction: string } | null;
  // Why-parked filter (the reason strip above the table). Empty = every backlog candidate.
  labelFilter: BacklogLabelFilter;
  data: RawTalentRow[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
  loading: boolean;
  error: string | null;
}

const initialState: BacklogState = {
  filters: EMPTY_FILTERS,
  search: '',
  sort: null,
  labelFilter: { reasons: [], categories: [] },
  data: [],
  pagination: { page: 1, pageSize: 20, total: 0, totalPages: 0 },
  loading: false,
  error: null,
};

export default function backlogReducer(
  state: BacklogState = initialState,
  action: BacklogAction,
): BacklogState {
  switch (action.type) {
    case BACKLOG_SET_FILTERS:
      return { ...state, filters: action.payload, pagination: { ...state.pagination, page: 1 } };
    case BACKLOG_CLEAR_FILTERS:
      return { ...state, filters: EMPTY_FILTERS, pagination: { ...state.pagination, page: 1 } };
    case BACKLOG_SET_LABEL_FILTER:
      return { ...state, labelFilter: action.payload, pagination: { ...state.pagination, page: 1 } };
    case BACKLOG_SET_SEARCH:
      return { ...state, search: action.payload, pagination: { ...state.pagination, page: 1 } };
    case BACKLOG_SET_SORT:
      return { ...state, sort: action.payload, pagination: { ...state.pagination, page: 1 } };
    case BACKLOG_SET_PAGE:
      return { ...state, pagination: { ...state.pagination, page: action.payload } };
    case BACKLOG_SET_PAGE_SIZE:
      return { ...state, pagination: { ...state.pagination, pageSize: action.payload, page: 1 } };
    case BACKLOG_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case BACKLOG_FETCH_SUCCESS:
      return { ...state, loading: false, data: action.payload.data, pagination: action.payload.pagination };
    case BACKLOG_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
